import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../Contexts/GlobalContext";
import { hideNav } from "../Utlils";
import { FaExclamationTriangle, FaArrowRight } from "react-icons/fa";

const AdditionalWarningBar = () => {
  const navigate = useNavigate();
  const { organization, user, setSnackbar } = useGlobalContext();
  const [shouldDisplay, setShouldDisplay] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (user && organization) {
        if (
          !Object.keys(organization?.addresses?.billingAddress || {})?.length &&
          user._id
        ) {
          setShouldDisplay(true);
        } else {
          setShouldDisplay(false);
        }
      }
    }, 1500);

    return () => clearTimeout(timer);
  }, [user?._id, organization?._id]);
  if (
    hideNav.some((data) => window.location.href.includes(data)) ||
    !shouldDisplay
  ) {
    return null;
  }
  return (
    <div
      className={`w-full bg-orange-50 border-l-4 border-orange-400 rounded-md shadow-sm my-3 ${
        hideNav?.some((data) => window.location.href?.includes(data))
          ? "hidden"
          : ""
      }`}
    >
      <div className="px-6 py-4 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 flex-1">
          <div className="flex-shrink-0">
            <FaExclamationTriangle className="text-orange-500" size={20} />
          </div>
          <div className="flex-1">
            <h3 className="text-[#333] text-[14px] font-[600] mb-0.5">
              Billing Information Required
            </h3>
            <p className="text-[#666] text-[13px] font-[400]">
              Your organization's billing address and details are missing. Please complete them to continue.
            </p>
          </div>
        </div>
        <button
          className="flex-shrink-0 bg-[#0226BE] text-white px-5 py-2 text-[13px] font-[500] rounded-md hover:bg-[#021ea8] transition-colors flex items-center gap-2 whitespace-nowrap"
          onClick={() => {
            if (user?.role === "admin") {
              navigate("/onboarding");
            } else {
              setSnackbar({
                open: true,
                msg: "Only admins are allowed to change organization details !",
                severity: "warning",
              });
            }
          }}
        >
          Complete Setup
          <FaArrowRight size={12} />
        </button>
      </div>
    </div>
  );
};

export default AdditionalWarningBar;
